<template>
    <v-row no-gutters class="mb-1">
        <v-col cols="12" md="2" class="pe-1">
            <v-autocomplete
                :prefix="`#${index+1}`"
                label="Item"
                :value="item_id"
                @input="$emit('update:item_id', $event)"
                :items="items"
                :loading="itemLoading"
                item-text="display_name"
                item-value="id"
                @update:search-input="searchItems"
                @change="$emit('update:measure_unit_id', null)"
                outlined
                :rules="[isRequired]"
                dense
                hide-details="auto"
                >
            </v-autocomplete>
        </v-col>
        <v-col cols="12" md="1" class="pe-1">
            <v-text-field
            label="Qty"
            :value="quantity"
            :rules="[isRequired]"
            @input="$emit('update:quantity', $event)"
            outlined
            dense
            hide-details="auto"    
            ></v-text-field>
        </v-col>
        <v-col cols="12" md="1" class="pe-1">
            <v-autocomplete
                label="Unit"
                :rules="[isRequired]"
                :value="measure_unit_id"
                @input="$emit('update:measure_unit_id', $event)"
                :items="measureUnits"
                item-text="abbreviation"
                item-value="id"
                outlined
                dense
                hide-details="auto">
            </v-autocomplete>
        </v-col>
        <v-col cols="12" md="1" class="pe-1">
            <v-text-field
            label="Unit Value"
            :value="unit_value"
            :rules="[isRequired]"
            @input="$emit('update:unit_value', $event)"
            outlined
            dense
            hide-details="auto"    
            ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="pe-1">
            <v-text-field
            label="Total Value"
            :value="total_value"
            outlined
            readonly
            class="font-weight-bold disabled"
            dense
            hide-details="auto"    
            ></v-text-field>
        </v-col>
        <v-col cols="12" md="1" class="pe-1">
            <v-text-field
            label="Unit Cost"
            :value="unit_cost"
            outlined
            class="font-weight-bold disabled"
            readonly
            dense
            hide-details="auto"
            ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="pe-1">
            <v-text-field
            label="Total Cost"
            :value="total_cost"
            outlined
            readonly
            class="font-weight-bold disabled"
            dense
            hide-details="auto"
            ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="pe-1">
            <div class="d-flex align-center ">
                <v-text-field
                    label="Total Value with Cost"
                    :value="total_value_with_cost"
                    outlined
                    class="font-weight-bold disabled"
                    dense
                    hide-details="auto"
                    readonly    
                ></v-text-field>
                <v-btn icon @click="$emit('remove')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import item from './../../services/purchase/item';
import { isRequired } from './../../utils/validations';

export default {
    props: {
        index: [String, Number],
        item_id: [String, Number],
        quantity: [String, Number],
        measure_unit_id: [String, Number],
        unit_value: [String, Number],
        total_value: [String, Number],
        unit_cost: [String, Number],
        total_cost: [String, Number],
        total_value_with_cost: [String, Number],
        items: Array
    },
    data() {
        return {
            itemLoading: false,
        }
    },
    computed: {
        measureUnits() {
            if(!this.item) return [];
            if(!Array.isArray(this.item.measure_units)) return [];
            return this.item.measure_units;
        },
        item() {
            return this.items.find(each => each.id == this.item_id);
        }
    },
    methods: {
        isRequired,
        searchItems(query) {
            this.itemLoading = true;
            item.search(query).then(res => {
                this.$emit("update:items", [...this.items, ...res.data]);
            }).finally(() => {
                this.itemLoading = false;
            })
        }
    }
}
</script>

<style>

</style>